import { TABLE_DATA, TABLE_SCHEMA } from '@/main/store/listEditTypes';

import { NAHRADY } from '../constants';

export const VYDEJ_DILU = 'vydejDilu';
export const JEDNOTNA_FRONTA_PRACOVNIK_SELECT_MAPPER = 'JEDNOTNA_FRONTA_PRACOVNIK_SELECT_MAPPER';
export const UPDATE_TABLE_SCHEMA = 'UPDATE_TABLE_SCHEMA';
export const UPDATE_TABLE_DATA = 'UPDATE_TABLE_DATA';
export const OZNAC_HROMADNU_OBJ = 'oznacHromadnuObj';
export const OZNAC_HROMADNY_VYDEJ = 'ozancHromadnyVydej';
export const OZNAC_HROMAD_REZER = 'oznacHromadRezar';

export const listActions = <const>{
	Nahrady_TABLE_SCHEMA: 'nahradyTableSchema',
	Nahrady_TABLE_DATA: 'nahradyTableData',
};
export const listMutations = <const>{
	ZAKAZKA_SELECT_MAPPER: 'zakazkaSelectMapper',
	PRACOVNIK_SELECT_MAPPER: 'pracovnikSelectMapper',
};

export const editMutations = <const>{
	ND_NR_MAPPER: 'ndNrMapper',
};
// Typescript cannot correctly infer values of these expressions, even though they are const.
console.assert(`${NAHRADY}_${TABLE_SCHEMA}` === 'Nahrady_TABLE_SCHEMA');
console.assert(`${NAHRADY}_${TABLE_DATA}` === 'Nahrady_TABLE_DATA');
